// -----------------------------------------------------------------------
// <copyright file="DafExecutingStatus.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum DafExecutingStatus {
  NotStarted = 0,
  Executing = 1,
  Succeed = 2,
  Failed = 3,
  Disabled = 4,
}
